var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegister(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3,3.1l-1.4,2.5l-2.5-1.4l-3.8,7l1.3,0.7l3.1-5.7l1.3,0.7L22.7,35.6l-0.3,8l6.6-4.6L46.6,6.6L40.3,3.1z M28,38l-4,2.8 l0.2-4.8L40.8,5.1l3.8,2.1L28,38z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.3,30.8v15.9H4.1V8.6H12l-0.9,3.6h16.2l-0.9-3.6h6.8L34,7.1h-7.9L25.5,5h-2.7V2.1h-7.2V5h-2.7l-0.5,2.2H2.7v41h33.1v-20 L34.3,30.8z M14,6.4h3V3.5h4.3v2.9h3l1.1,4.3H12.9L14,6.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegister);
export default __webpack_public_path__ + "static/media/register.5180111e50b97f605160b3b191bb8d2e.svg";
export { ForwardRef as ReactComponent };